import {
  getRawJwt, setRawJwt, clearRawJwt, parseJwt,
} from '../../util/jwt';
import { clients } from '../../util/clients';

// Self-contained login: this app owns its own users/JWTs via
// tmc-abstract-images-backend's POST /api/auth/login (bcrypt + JWT) --
// it does NOT depend on tmc-local-auth's user base (different customer
// base entirely: Abstract Companies, not Treasurer's offices). See
// CLAUDE.md "Decisions confirmed with Michael" #4.
export const token = {
  namespaced: true,
  state: () => ({
    authJwt: undefined,
    authUser: undefined,
    authRole: undefined,
    authExp: undefined,
    loginError: undefined,
    loggingIn: false,
  }),
  mutations: {
    setLoggedIn(state, { jwt, username, role }) {
      state.authJwt = jwt;
      state.authUser = username;
      state.authRole = role;
      const decoded = parseJwt(jwt);
      state.authExp = decoded.exp;
      state.loginError = undefined;
      setRawJwt(jwt);
    },
    setLoggedOut(state) {
      state.authJwt = undefined;
      state.authUser = undefined;
      state.authRole = undefined;
      state.authExp = undefined;
      clearRawJwt();
    },
    setLoginError(state, message) {
      state.loginError = message;
    },
    setLoggingIn(state, loggingIn) {
      state.loggingIn = loggingIn;
    },
    // re-hydrate from localStorage on app boot / page refresh
    rehydrateLogin(state) {
      const jwt = getRawJwt();
      if (!jwt) return;
      try {
        const decoded = parseJwt(jwt);
        if (decoded.exp && decoded.exp * 1000 < Date.now()) {
          clearRawJwt();
          return;
        }
        state.authJwt = jwt;
        state.authUser = decoded.username;
        state.authRole = decoded.role;
        state.authExp = decoded.exp;
      } catch (e) {
        clearRawJwt();
      }
    },
  },
  actions: {
    async login({ commit }, { username, password }) {
      commit('setLoggingIn', true);
      commit('setLoginError', undefined);
      try {
        const res = await clients.direct.backendRest.post('/auth/login', { username, password });
        const { jwt, username: loggedInUsername, role } = res.data;
        commit('setLoggedIn', { jwt, username: loggedInUsername, role });
        return true;
      } catch (err) {
        const message = (err.response && err.response.data && err.response.data.message)
          || 'Login failed. Check your username and password.';
        commit('setLoginError', message);
        return false;
      } finally {
        commit('setLoggingIn', false);
      }
    },
    logout({ commit }) {
      commit('setLoggedOut');
    },
  },
  getters: {
    authUser: (state) => state.authUser || 'anonymous',
    isLoggedIn: (state) => Boolean(state.authJwt) && Boolean(state.authExp)
      && state.authExp * 1000 > Date.now(),
    authRole: (state) => state.authRole,
  },
};

export default token;
